export default __webpack_public_path__ + "static/media/img1.bb66e803.png";